import { TRoomDetail } from '@/entities/room'

import { Heading } from '../common'
import { LocationMap } from './location-map'

export type Props = Pick<
  TRoomDetail,
  'addrLot' | 'lat' | 'lng' | 'subwayStations'
>

export const Location = ({ addrLot, lat, lng, subwayStations }: Props) => {
  const hasNearbySubwayStations = subwayStations.length > 0

  return (
    <section>
      <Heading className="mb-3">위치</Heading>
      <p className="typo-body2 mb-5 font-semibold text-gray-900">{addrLot}</p>
      <div className="bg-gray-0 h-[260px] w-[710px] overflow-hidden rounded-sm">
        <LocationMap lat={lat} lng={lng} />
      </div>
      {hasNearbySubwayStations && (
        <ul className="typo-body2 mt-5 flex gap-2 text-gray-900">
          {subwayStations.map(station => (
            <li key={station}>
              <span className="bg-gray-0 typo-body2 block h-9.5 w-fit rounded-full px-3.5 py-2 font-semibold text-black">
                {station}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
